/**
 * QA mode: session cookie and data-qa-mode flag for automated tests.
 * Popup/modal hiding is handled in snippets/qa-mode.liquid ({% stylesheet %}).
 */
// @ts-nocheck

class QAMode extends HTMLElement {
  static COOKIE_NAME = 'qa_mode';
  static COOKIE_VALUE = '1';

  connectedCallback() {
    QAMode.syncSessionFromUrl();

    if (!QAMode.isEnabled()) {
      return;
    }

    QAMode.setDocumentState(true);
  }

  /**
   * @returns {boolean}
   */
  static isEnabled() {
    const params = new URLSearchParams(window.location.search);

    if (params.get('qa_mode') === 'true') {
      return true;
    }

    if (document.documentElement.dataset.qaMode === 'true') {
      return true;
    }

    return document.cookie.split('; ').some((row) => {
      if (!row.startsWith(`${QAMode.COOKIE_NAME}=`)) {
        return false;
      }

      const value = row.slice(QAMode.COOKIE_NAME.length + 1);

      return value === QAMode.COOKIE_VALUE || value === 'true';
    });
  }

  /**
   * @param {boolean} enabled
   */
  static setDocumentState(enabled) {
    if (enabled) {
      document.documentElement.dataset.qaMode = 'true';
    } else {
      delete document.documentElement.dataset.qaMode;
    }
  }

  /**
   * @param {string} name
   * @param {string} value
   */
  static writeSessionCookie(name, value) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; SameSite=Lax${secure}`;
  }

  /**
   * @param {string} name
   */
  static clearCookie(name) {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${name}=; path=/; Max-Age=0; SameSite=Lax${secure}`;
  }

  static syncSessionFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const param = params.get('qa_mode');

    if (param === 'true') {
      QAMode.writeSessionCookie(QAMode.COOKIE_NAME, QAMode.COOKIE_VALUE);
      QAMode.setDocumentState(true);

      return;
    }

    if (param === 'false') {
      QAMode.clearCookie(QAMode.COOKIE_NAME);
      QAMode.setDocumentState(false);
    }
  }
}

QAMode.syncSessionFromUrl();

if (!customElements.get('qa-mode')) {
  customElements.define('qa-mode', QAMode);
}

if (typeof window !== 'undefined') {
  window.OtterQaMode = {
    isEnabled: () => QAMode.isEnabled(),
    syncSessionFromUrl: () => QAMode.syncSessionFromUrl(),
  };
}

export { QAMode };
